import { SPECIAL_LUNAR_NOTES } from './lunarConstants';

export const getLunarSpecialNote = (lunar, language = 'vi') => {
  if (!lunar?.day) return null;
  const locale = SPECIAL_LUNAR_NOTES[language] ? language : 'vi';
  return SPECIAL_LUNAR_NOTES[locale][lunar.day] || null;
};
